// Accepts date strings with format:
// - "yyyy-mm-ddThh:mm:ss"
// - "yyyy-mm-dd"
// - "yyyymmddThh:mm:ss"
// - "yyyymmdd"
export const ISODateStringToUTCDate = (dateString: string): Date => {
  if (!dateString.includes('-') && dateString.length >= 8) {
    dateString = `${dateString.slice(0, 4)}-${dateString.slice(4, 6)}-${dateString.slice(6, 8)}`;
  }
  return new Date(dateString.split('T')[0]);
};
